<template>
  <div class="dianJin-item" @click="showDialog()">
    <div class="dianJin-item-content">
      <div class="dianJin-item-title">
        {{ dianJinItemData.dianJinInfo.title }}
      </div>
      <div class="dianJin-item-desc">
        <div class="wrap">
          <div
            class="lock-icon"
            v-if="
              !dianJinItemData.dianJinInfo.isObtained &&
                !dianJinItemData.dianJinInfo.isFree
            "
          ></div>
          <div class="author-name">
            <img
              class="author-portrait"
              :src="dianJinItemData.authorInfo.headPic"
            />
            <div>{{ dianJinItemData.authorInfo.nickName }}</div>
          </div>
        </div>
        <div class="desc">
          {{ dianJinItemData.dianJinInfo.publishTimeDesc }}
        </div>
      </div>
    </div>
    <div class="dianJin-item-img">
      <img :src="dianJinItemData.dianJinInfo.coverImageUrl" alt="" />
      <!--      <div class="tag">-->
      <!--        {{ dianJinItemData.tag }}-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { Dialog, Toast } from 'vant'
import api from '../../api/api'
import { openurl } from '@em/ym'

export default {
  name: 'dianJinItem',
  computed: {
    dayjs() {
      return dayjs
    }
  },
  props: ['dianJinItemData', 'couponNo'],
  data() {
    return {
      lookTime: 0
    }
  },
  methods: {
    showDialog() {
      const item = this.dianJinItemData
      console.info(item)
      if (item.isAvailable) {
        // 有权限就不用再调用了
        Dialog.alert({
          message: `已有权限，无需解锁`,
          confirmButtonColor: '#046bcc'
        })
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `确定解锁“${item.dianJinInfo.title}”吗？`,
        confirmButtonColor: '#046bcc',
        cancelButtonColor: '#999'
      })
        .then(() => {
          // on confirm
          this.creteUnlockOrder()
        })
        .catch(() => {
          // on cancel
        })
    },

    async creteUnlockOrder() {
      Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      const item = this.dianJinItemData
      console.info('item', item)
      const { detail, result } = await api.course.creteCouponOrder({
        productId: item.dianJinInfo.productId,
        subProductId: item.dianJinInfo.id,
        couponNo: this.couponNo
      })
      if (result.code === 0) {
        console.info('detail', detail)
        const orderId = detail
        this.getExchangeResult(orderId)
      }
    },
    async getExchangeResult(orderId) {
      const { detail, result } = await api.course.getExchangeResult({
        orderId
      })
      if (result.code === 0 && detail.success) {
        console.info('detail', detail)
        this.$set(this.dianJinItemData, 'isAvailable', true)
        // 手动清除 Toast
        Toast.clear()

        Dialog.alert({
          message: `解锁成功！`,
          confirmButtonColor: '#046bcc',
          confirmButtonText: '去查看',
          className: 'unlock-success'
        }).then(() => {
          openurl(this.dianJinItemData.dianJinInfo.uri)
        })
      } else {
        this.lookTime++
        if (this.lookTime < 5) {
          setTimeout(() => {
            this.getExchangeResult(orderId)
          }, 1000)
        } else {
          // 手动清除 Toast
          Toast.clear()
          Dialog.alert({
            message: `${detail.message}`,
            confirmButtonColor: '#046bcc',
            confirmButtonText: '确定'
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dianJin-item {
  display: flex;
  padding: 16px;
  border-radius: 8px;
  background: rgba(245, 245, 245, 1);
  margin-bottom: 20px;
  .dianJin-item-img {
    position: relative;
    width: 200px;
    height: 150px;
    border-radius: 4px;
    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      background: rgba(0, 0, 0, 0.25);
      color: #ffffff;
      font-size: 24px;
      padding: 0 10px;
      border-radius: 4px;
    }
    img {
      width: 100%;
      height: 100%;
      display: block;
      border-radius: 10px;
    }
  }
  .dianJin-item-content {
    flex: 1;
    padding: 0 10px;
    margin-right: 20px;
    .dianJin-item-title {
      font-size: 32px;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 10px;
    }
    .dianJin-item-desc {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 56px;
      .wrap {
        display: flex;
        align-items: center;
      }
      .lock-icon {
        width: 46px;
        height: 47px;
        background: url('./images/lock_icon.png') no-repeat center;
        background-size: cover;
        margin-right: 20px;
      }
      .author-name {
        display: flex;
        align-items: center;
        color: rgba(50, 50, 50, 1);
        font-size: 24px;
        background-color: rgba(232, 232, 232, 1);
        border-radius: 82px;
        font-size: 24px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .desc {
        width: fit-content;
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 80px;
        background: rgba(232, 232, 232, 1);
        color: rgba(50, 50, 50, 1);
        font-size: 24px;
        padding: 0 20px;
        max-width: 268px;
        flex: none;
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.unlock-success {
  .van-dialog__message {
    font-size: 32px;
  }
}
</style>
